const configuredBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").trim();

export const BACKEND_URL = configuredBackendUrl.replace(/\/+$/, "");
export const API = `${BACKEND_URL}/api`;

